import isNil from 'lodash/isNil';
import { formatThousands } from '@/utils/util-functions';

export interface BarPopoverProps {
  min?: number;
  max?: number;
  unit: string;
  value?: number;
}

export const formatValueOrRange = (value?: number, min?: number, max?: number): string => {
  return value
    ? formatThousands(value)
    : `${!isNil(min) ? formatThousands(min) : ''} - ${!isNil(max) ? formatThousands(max) : ''}`;
};
